import axios from 'axios';
import { getFromStorage } from "@/helpers/backendStorage";

export default {
  namespaced: true,
  state: {
    all: [],
    attachments: [],
  },
  getters: {
    getAll(state) {
      return state.all;
    },
    byId(state) {
      return state.all.reduce((total, current) => {
        total[current.id] = current;
        return total
      }, {})
    },
    getAttachmentsById(state){
      return state.attachments.reduce((total, current) => {
        total[current.id] = current;
        return total
      }, {})
    },
    getSingleAttachmentTypes(state){
      let imageName = "image_single";
      return state.attachments.filter((attachments) => {
        return getFromStorage(attachments[imageName]);
      });
    },
    getDoubleAttachmentTypes(state){
      let imageName = "image_double";
      return state.attachments.filter((attachments) => {
        return getFromStorage(attachments[imageName]);
      });
    },
  },
  actions: {
    index({ commit }) {
      return axios.get(process.env.VUE_APP_API_URL + 'cilinders')
        .then(({ data }) => {
          commit('setCilinders', data.cilinders);
          commit('setAttachments', data.attachments);
        });
    },
  },
  mutations: {
    setCilinders(state, cilinders) {
      if(!cilinders.length > 0) return;

      state.all = cilinders;
    },
    setAttachments(state, attachments) {
      if(!attachments.length > 0) return;

      state.attachments = attachments;
    },
    clearCylinders(state) {
      state.all = [];
      state.attachments = [];
    }
  },
};
